export const course = [
  // {
  //   id: 1,
  //   name: "One Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 2,
  //   name: "Two Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 3,
  //   name: "Three Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 4,
  //   name: "Four Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 5,
  //   name: "Five Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 6,
  //   name: "Six Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 7,
  //   name: "seven Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 8,
  //   name: "eight Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id: 9,
  //   name: "nine Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
  // {
  //   id:10,
  //   name: "ten Page",
  //   elements: [
  //     {
  //       id: 1,
  //       name: "Text with Image",
  //       exist: false
  //     },
  //     {
  //       id: 2,
  //       name: "Text",
  //       exist: false
  //     },
  //     {
  //       id: 3,
  //       name: "Slider with text",
  //       exist: false
  //     },
  //     {
  //       id: 4,
  //       name: " Content Editor",
  //       exist: false
  //     },
  //     {
  //       id: 5,
  //       name: "Image",
  //       exist: false
  //     },
  //     {
  //       id: 6,
  //       name: "Banner",
  //       exist: false
  //     }
  //   ]
  // },
];

export const elements = [
  {
    id: "1",
    type: "1",
    name: "Text with Image",
    exist: false,
    data: {
      text: "",
      image: ""
    }
  },
  {
    id: "2",
    type: "2",
    name: "Text",
    exist: false,
    data: {
      text: ""
    }
  },
  // {
  //   id: "3",
  //   type: "3",
  //   name: "Slider with text",
  //   exist: false,
  //   data: [
  //     { text: "", image: "" },
  //     { text: "", image: "" },
  //     { text: "", image: "" }
  //   ]
  // },
  // {
  //   id: "4",
  //   type: "4",
  //   name: " Content Editor",
  //   exist: false
  // },
  // {
  //   id: "5",
  //   type: "5",
  //   name: "Image",
  //   exist: false
  // },
  // {
  //   id: "6",
  //   type: "6",
  //   name: "Banner",
  //   exist: false
  // }
];
